<div class="table">
    <section>
        <div class="justify-content-end m-1 d-flex">
            <ng-content select="[actions]"></ng-content>
        </div>
        <ng-content select="[search]"></ng-content>
        <div class="table-content">
            <ng-container *ngIf="!isMobileScreen">
                <table
                    mat-table
                    [id]="config.id ?? 'table'"
                    [dataSource]="config.dataSource!.filteredData!"
                    aria-describedby="Dynamic Table"
                    (matSortChange)="onSortChange($event)"
                    matSort
                    class="table-content"
                >
                    <ng-container *ngFor="let column of config!.displayedColumns; let i = index" [matColumnDef]="column.label">
                        <ng-container *ngIf="!column.isSortable; else sortableHeader">
                            <th *matHeaderCellDef mat-header-cell>
                                <div class="d-flex">
                                    {{ config.isTranslated ? (column.label! | translate) : column.label }}
                                    <ng-container *ngIf="column.isFiltration">
                                        <app-tqw-filter-dropdown
                                            [list]="column.filtrationList"
                                            [column]="column.label"
                                            [filterKey]="column.filtrationKey"
                                            (OnSelectFilter)="OnSelectFilter($event)"
                                        >
                                        </app-tqw-filter-dropdown>
                                    </ng-container>
                                </div>
                            </th>
                        </ng-container>
                        <ng-template #sortableHeader>
                            <th *matHeaderCellDef [mat-sort-header]="column.path" mat-header-cell>
                                {{ config.isTranslated ? (column.label! | translate) : column.label }}
                            </th>
                        </ng-template>

                        <td *matCellDef="let element" mat-cell>
                            <ng-container [ngSwitch]="column.type">
                                <ng-container [ngSwitch]="column?.type">
                                    <ng-container *ngSwitchCase="ColumnTypes.Image">
                                        <ng-container *ngTemplateOutlet="ColumnTypesImage; context: { column, item: element }"> </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="ColumnTypes.Text">
                                        <ng-container *ngTemplateOutlet="ColumnTypesText; context: { column, item: element }"> </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="ColumnTypes.Currency">
                                        <ng-container *ngTemplateOutlet="ColumnTypesCurrency; context: { column, item: element }"> </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="ColumnTypes.Number">
                                        <ng-container *ngTemplateOutlet="ColumnTypesNumber; context: { column, item: element }"> </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="ColumnTypes.Date">
                                        <ng-container *ngTemplateOutlet="ColumnTypesDate; context: { column, item: element }"> </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="ColumnTypes.Content">
                                        <ng-container *ngTemplateOutlet="ColumnTypesContent; context: { column, item: element }"> </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="ColumnTypes.Boolean">
                                        <ng-container *ngTemplateOutlet="ColumnTypesBoolean; context: { column, item: element }"> </ng-container>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="ColumnTypes.Actions">
                                        <ng-container [ngSwitch]="column.actionsStyle">
                                            <ng-container *ngSwitchCase="ActionsStyle.Dots">
                                                <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                                                    <mat-icon>more_vert</mat-icon>
                                                </button>
                                                <mat-menu #actionsMenu="matMenu">
                                                    <ng-container *ngTemplateOutlet="ColumnTypesActions; context: { column, item: element }"> </ng-container>
                                                </mat-menu>
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <ng-container *ngTemplateOutlet="ColumnTypesActions; context: { column, item: element }"> </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </td>
                    </ng-container>

                    <tr *matHeaderRowDef="getColumnsName()" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: getColumnsName()" mat-row></tr>
                    <tr *matNoDataRow>
                        <td [attr.colSpan]="getColumnsName()?.length">
                            <app-twq-not-found-data *ngIf="!config.isLoading" class="d-flex justify-content-center"></app-twq-not-found-data>
                        </td>
                    </tr>
                </table>
                <app-twq-pagination
                    *ngIf="!config.isLoading"
                    (pageIndexChange)="onPaginatorChange($event)"
                    [config]="{
                        totalItems: config.totalElements || 0,
                        pageSize: (config.pageSize || defaultConfig.pageSize)!,
                        pageIndex: (config.pageIndex - 1 || defaultConfig.pageIndex)!,
                        page: config.pageIndex
                    }"
                ></app-twq-pagination>
            </ng-container>
            <ng-container *ngIf="isMobileScreen">
                <ng-container *ngFor="let item of mobileData">
                <app-tqw-view [config]="mobileViewConfig">
                    <ng-template #viewItem let-viewItem="item" let-i="index">
                      <app-tqw-view-item [class.row-odd]="(i+1) % 2 !== 0" [class.row-even]="(i+1) % 2 === 0"  class="d-block" [config]="{label: viewItem.label, class:'d-flex align-items-center justify-content-between bg-transparent'}">
                        <ng-template #viewItemValue>
                          <ng-container [ngSwitch]="viewItem?.value?.type">
                            <ng-container *ngSwitchCase="ColumnTypes.Image">
                              <ng-container
                                *ngTemplateOutlet="ColumnTypesImage; context: { column: viewItem?.value, item }">
                              </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnTypes.Text">
                              <ng-container
                                *ngTemplateOutlet="
                                  ColumnTypesText;
                                  context: { column: viewItem?.value, item }
                                "
                              >
                              </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnTypes.Currency">
                              <ng-container
                                *ngTemplateOutlet="
                                  ColumnTypesCurrency;
                                  context: { column: viewItem?.value, item }
                                "
                              >
                              </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnTypes.Number">
                              <ng-container
                                *ngTemplateOutlet="
                                  ColumnTypesNumber;
                                  context: { column: viewItem?.value, item }
                                "
                              >
                              </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnTypes.Date">
                              <ng-container
                                *ngTemplateOutlet="
                                  ColumnTypesDate;
                                  context: { column: viewItem?.value, item }
                                "
                              >
                              </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnTypes.Content">
                              <ng-container
                                *ngTemplateOutlet="
                                  ColumnTypesContent;
                                  context: { column: viewItem?.value, item }
                                "
                              >
                              </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="ColumnTypes.Boolean">
                              <ng-container
                                *ngTemplateOutlet="
                                  ColumnTypesBoolean;
                                  context: { column: viewItem?.value, item }
                                "
                              >
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </ng-template>
                      </app-tqw-view-item>
                    </ng-template>
                  </app-tqw-view>
                </ng-container>
            </ng-container>
            <div class="d-flex justify-content-around" *ngIf="config.isLoading">
                <!-- <app-twq-loading-spinner class="d-block p-4" [color]="config.spinnerColor"></app-twq-loading-spinner> -->
                <app-loader [fullLoader]="false"></app-loader>
            </div>
        </div>
    </section>
</div>

<ng-template #ColumnTypesText let-column="column" let-item="item">
    <span
        [matTooltipPosition]="'above'"
        [matTooltip]="column?.isTruncated ? (item | mapValue : column?.path) : ''"
        [class.text-truncated]="column?.isTruncated"
        [style.maxWidth.px]="column?.isTruncated ? column?.truncatedWidth || '200' : 'unset'"
        >{{ column.isValueTranslated ? ((item | mapValue : column?.path)! | translate) : (item | mapValue : column?.path) }}</span
    >
</ng-template>
<ng-template #ColumnTypesImage let-column="column" let-item="item">
    <img
        [src]="item | mapValue : column?.path"
        [alt]="column.isValueTranslated ? ((item | mapValue : column?.path)! | translate) : (item | mapValue : column?.path)"
        class="rounded-5 p-2 rounded-circle"
        width="50"
    />
</ng-template>
<ng-template #ColumnTypesDate let-column="column" let-item="item">
    {{ item | mapValue : column?.path | date : column?.format }}
</ng-template>
<ng-template #ColumnTypesNumber let-column="column" let-item="item">
    <span
        [matTooltipPosition]="'above'"
        [matTooltip]="
            column?.isTruncated
                ? column?.withoutComma
                    ? (item | mapValue : column?.path : column?.withoutComma | number)
                    : (item | mapValue : column?.path)
                : ''
        "
        [class.text-truncated]="column?.isTruncated"
        [style]="column?.isTruncated ? 'max-width:' + (column?.truncatedWidth || '200') + 'px' : 'unset'"
    >
        {{ column?.withoutComma ? (item | mapValue : column?.path : column?.withoutComma | number) : (item | mapValue : column?.path) }}
    </span>
</ng-template>
<ng-template #ColumnTypesCurrency let-column="column" let-item="item">
    <span
        [matTooltipPosition]="'above'"
        [matTooltip]="column?.isTruncated ? (item | mapValue : column?.path : true | currency : column?.currency)! : ''"
        [class.text-truncated]="column?.isTruncated"
        [style.maxWidth.px]="column?.isTruncated ? column?.truncatedWidth || '200' : 'unset'"
    >
        {{ item | mapValue : column?.path : true | currency : column?.currency }}
    </span>
</ng-template>
<ng-template #ColumnTypesContent let-column="column" let-item="item">
    <ng-container [ngTemplateOutlet]="contents[column?.contentIndex || 0]" [ngTemplateOutletContext]="{ item: item }"> </ng-container>
</ng-template>
<ng-template #ColumnTypesBoolean let-column="column" let-item="item">
    <span
        [matTooltipPosition]="'above'"
        [matTooltip]="
            column?.isTruncated ? (column?.mapValues && (column?.mapValues)![item | mapValue : column?.path]) || (item | mapValue : column?.path) : ''
        "
        [class.text-truncated]="column?.isTruncated"
        [style.maxWidth.px]="column?.isTruncated ? column?.truncatedWidth || '200' : 'unset'"
    >
        {{
            column.isValueTranslated
                ? (((column?.mapValues && (column?.mapValues)![item | mapValue : column?.path]) || (item | mapValue : column?.path))! | translate)
                : (column?.mapValues && (column?.mapValues)![item | mapValue : column?.path]) || (item | mapValue : column?.path)
        }}
    </span>
</ng-template>
<ng-template #ColumnTypesActions let-column="column" let-item="item"> </ng-template>
